"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchingVehicleIdsReducer = void 0;
const matchingVehicles_1 = require("../actions/matchingVehicles");
const initState = [];
const matchingVehicleIdsReducer = (vehicleIdsArray = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case matchingVehicles_1.SET_MATCHING_VEHICLE_IDS:
            return [...action.payload];
        case matchingVehicles_1.REMOVE_MATCHING_VEHICLE_IDS:
            return [];
        default:
            return vehicleIdsArray;
    }
};
exports.matchingVehicleIdsReducer = matchingVehicleIdsReducer;
//# sourceMappingURL=matchingVehicleIds.reducer.js.map